/**
 * accordion — 汎用アコーディオン
 *
 * 期待するマークアップ:
 *   <div class="c-accordion" data-sp-accordion>
 *     <div class="c-accordion__item">
 *       <h3 class="c-accordion__heading">
 *         <button class="c-accordion__trigger" type="button"
 *                 aria-expanded="false" aria-controls="PANEL_ID" id="BTN_ID">...</button>
 *       </h3>
 *       <div class="c-accordion__panel" id="PANEL_ID" role="region" aria-labelledby="BTN_ID">
 *         <div class="c-accordion__body">...</div>
 *       </div>
 *     </div>
 *   </div>
 *
 * id / aria-controls / aria-labelledby が無ければ自動採番して補う。
 * button 要素なのでキーボード操作（Enter / Space）は既定動作に任せる。
 * 同一アコーディオン内の trigger 間は ArrowUp / ArrowDown / Home / End で移動できる。
 */

let uid = 0;

function ensureIds(item) {
  const trigger = item.querySelector(".c-accordion__trigger");
  const panel = item.querySelector(".c-accordion__panel");
  if (!trigger || !panel) {
    return null;
  }
  uid += 1;
  if (!trigger.id) {
    trigger.id = `sp-acc-${uid}-trigger`;
  }
  if (!panel.id) {
    panel.id = `sp-acc-${uid}-panel`;
  }
  trigger.setAttribute("aria-controls", panel.id);
  if (!panel.hasAttribute("role")) {
    panel.setAttribute("role", "region");
  }
  panel.setAttribute("aria-labelledby", trigger.id);
  if (!trigger.hasAttribute("aria-expanded")) {
    trigger.setAttribute("aria-expanded", "false");
  }
  return { trigger, panel };
}

function setOpen(item, trigger, panel, open) {
  item.classList.toggle("is-open", open);
  trigger.setAttribute("aria-expanded", open ? "true" : "false");
  panel.toggleAttribute("inert", !open);
}

function initOne(accordion) {
  const items = Array.from(accordion.querySelectorAll(".c-accordion__item"));
  const triggers = [];

  items.forEach((item) => {
    const parts = ensureIds(item);
    if (!parts) {
      return;
    }
    const { trigger, panel } = parts;
    // /faq/#faq-cancel のようにリンクで来た質問は、開いた状態で見せる。
    const startOpen = item.classList.contains("is-open") || (item.id !== "" && window.location.hash === `#${item.id}`);
    setOpen(item, trigger, panel, startOpen);
    triggers.push(trigger);

    trigger.addEventListener("click", () => {
      const willOpen = trigger.getAttribute("aria-expanded") !== "true";
      setOpen(item, trigger, panel, willOpen);
    });

    trigger.addEventListener("keydown", (event) => {
      const index = triggers.indexOf(trigger);
      let next = -1;
      if (event.key === "ArrowDown") {
        next = (index + 1) % triggers.length;
      } else if (event.key === "ArrowUp") {
        next = (index - 1 + triggers.length) % triggers.length;
      } else if (event.key === "Home") {
        next = 0;
      } else if (event.key === "End") {
        next = triggers.length - 1;
      }
      if (next >= 0) {
        event.preventDefault();
        triggers[next].focus();
      }
    });
  });
}

export function initAccordion(root = document) {
  const accordions = Array.from(root.querySelectorAll("[data-sp-accordion]"));
  accordions.forEach(initOne);
}
